/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=5ee4f200"
import script from "./PatientView.vue?vue&type=script&lang=js"
export * from "./PatientView.vue?vue&type=script&lang=js"
import style0 from "./PatientView.vue?vue&type=style&index=0&id=5ee4f200&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee4f200')) {
      api.createRecord('5ee4f200', component.options)
    } else {
      api.reload('5ee4f200', component.options)
    }
    module.hot.accept("./PatientView.vue?vue&type=template&id=5ee4f200", function () {
      api.rerender('5ee4f200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PatientView.vue"
export default component.exports